module.exports = __webpack_public_path__ + "static/media/whisper.2ae33366.jpg";